import { Component } from '@angular/core';
import { selectUpdatePermissions, selectUpdatePermissionsAuthorization } from '../../application.selector';
import { Store } from '@ngrx/store';
import { ApplicationsState } from '../../applications.state';
import { Observable } from 'rxjs/Observable';
import * as updateActions from '../../actions/application-update-permissions.actions';
import { BsModalRef } from 'ngx-bootstrap';
import { ContainerComponent } from '../../../shared/components/container-component/unsubscribe.component';
import { ApplicationUpdatePermissions } from '../../model/application/application-update-permissions.model';
import { selectLang } from '../../../url-params/url-params.selector';
import { AuthorizationResponse } from '../../../../core/model/authorization/authorization-response.model';
import { AuthorizationSecurityError } from '../../../../core/model/authorization/authorization-security-error.enum';

@Component({
    selector: 'ssf-update-apps-permissions-dialog',
    template: `
        <ssf-authorization-dialog 
            [signInfo]="(authorization$ | async)?.signInfo"
            [lang]="(lang$| async)"
            (onMessage)="onMessage($event)"
            (onAuthorizationSecurityError)="onAuthorizationSecurityError($event)"
            (onHide)="onHide()">
        </ssf-authorization-dialog>
    `
})
export class UpdatePermissionsDialogComponent extends ContainerComponent {
    public authorization$: Observable<ApplicationUpdatePermissions>;
    public lang$: Observable<string>;

    constructor(private store: Store<ApplicationsState>, public bsModalRef: BsModalRef) {
        super();

        this.authorization$ = this.store.select(selectUpdatePermissionsAuthorization);

        // modal is hidden when state.updatePermissions.shown === false; see reducer
        this.store.select(selectUpdatePermissions)
            .takeUntil(this.ngUnsubscribe)
            .filter((value) => !value.shown)
            .subscribe(() => bsModalRef.hide());

        this.lang$ = this.store.select(selectLang);
    }

    onMessage(event: AuthorizationResponse) {
        this.store.dispatch(new updateActions.UpdatePermissionsAuthFinishedAction(event));
    }

    onAuthorizationSecurityError(error: AuthorizationSecurityError) {
        this.store.dispatch(new updateActions.UpdatePermissionsAuthErrorAction(error));
    }

    onHide() {
        this.store.dispatch(new updateActions.UpdatePermissionsCancelAction());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/components/update-permissions-dialog/update-permissions-dialog.component.ts